import { capitalize } from 'helpers/utils';
import { useCallback, useEffect, useState } from 'react';
import { Dropdown, Nav } from 'react-bootstrap';
import { RouteItems, routes } from 'sitemap';
import { useTranslation } from 'react-i18next';
import ThemeToggler from 'components/common/ThemeToggler';
import TopNavMegaMenu from './TopNavMegaMenu';
import TopNavItem from './TopNavItem';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import { useLocation } from 'react-router-dom';

const NavbarTopNav = () => {
  return (
    <Nav className="navbar-nav-top pb-4 pb-lg-0 scrollbar d-flex align-items-center">
      {routes.map(route => (
        <NavbarTopNavItem route={route} key={route.label} />
      ))}
      <Nav.Item className="ms-auto">
        <ThemeToggler />
      </Nav.Item>
    </Nav>
  );
};

const NavbarTopNavItem = ({ route }: { route: RouteItems }) => {
  const Icon = route.icon;
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const { breakpoints } = useBreakpoints();
  
  const getTranslatedLabel = useCallback((route: RouteItems) => {
    const currentLang = i18n.language;
    const navLabel = route.horizontalNavLabel || route.label;
    
    if (currentLang === 'fr' && route.horizontalNavLabelFr) {
      return route.horizontalNavLabelFr;
    } else if (currentLang === 'en' && route.horizontalNavLabelEn) {
      return route.horizontalNavLabelEn;
    } else if (currentLang === 'fr' && route.labelFr) {
      return route.labelFr;
    } else if (currentLang === 'en' && route.labelEn) {
      return route.labelEn;
    }
    
    return capitalize(navLabel);
  }, [i18n.language]);

  const handleMouseEnter = () => {
    if (breakpoints.up('lg')) {
      setShow(true);
    }
  };

  const handleMouseLeave = () => {
    if (breakpoints.up('lg')) {
      setShow(false);
    }
  };

  useEffect(() => {
    if (show) {
      setShow(false);
    }
  }, [pathname]);

  return (
    <Dropdown
      as="li"
      show={show}
      className="nav-item"
      key={route.label}
      autoClose="outside"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onToggle={() => setShow(!show)}
    >
      <Dropdown.Toggle
        as="a"
        variant=""
        className="nav-link lh-1 d-flex align-items-center cursor-pointer"
        // onClick={handleClick}
      >
        <Icon className="me-2" size={16} />
        <span>
          {getTranslatedLabel(route)}
        </span>
      </Dropdown.Toggle>
      {route.megaMenu ? (
        <TopNavMegaMenu route={route} />
      ) : (
        <TopNavItem route={route} />
      )}
    </Dropdown>
  );
};

export default NavbarTopNav;
